<template>
  <div>
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />

    <!-- List of all topics section -->
    <v-container class="content">
      <!--loading screen when add video request is being handled-->
      <LoadingScreen :loading="loading2" />

      <div class="header text-left">Manage All Topics</div>
      <v-row>
        <v-col cols="12">
          <label style="margin-bottom: 0">Topic</label>
        </v-col>
        <v-col cols="6" md="3">
          <input type="text" v-model="topicToAdd" />
        </v-col>
        <v-col cols="6" md="3">
          <v-btn color="#00457C" :disabled="topicToAdd == ''" @click="addTopic"
            >Add</v-btn
          >
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="notifications"
        v-bind:dynamicHeaders="[
          { text: 'Topic', value: 'topic' },
          { text: 'Actions', value: 'actions' },
        ]"
        v-bind:dynamicWidths="['130px']"
        v-bind:dynamicRowsDetail="dynamicRowsDetail"
        v-on:delete-item="openDeleteDialog"
      />

      <v-row v-if="success2" style="margin-top: 20px">
        <v-col cols="12">
          <v-alert type="success">Topic added successfully.</v-alert>
        </v-col>
      </v-row>
      <v-row v-if="error2">
        <v-col cols="12">
          <v-alert type="error">Error occurred. Please try again.</v-alert>
        </v-col>
      </v-row>
    </v-container>

    <!-- Subscribe section -->
    <v-container class="content" style="margin-top: 25px">
      <!--loading screen when add video request is being handled-->
      <LoadingScreen :loading="loading" />

      <div class="header text-left">Subscribe Customers To Topics</div>
      <v-row>
        <v-col cols="12">
          <label style="margin-bottom: 0">CSV File</label>
        </v-col>
        <v-col cols="6" md="3">
          <input
            id="csvInput"
            type="file"
            accept=".csv"
            @change="(e) => setCsvData(e.target.files[0])"
          />
          <input type="text" readonly v-model="csvFileName" />
        </v-col>
        <v-col cols="6" md="3">
          <label for="csvInput" id="browse-btn">Browse</label>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" md="3">
          <v-btn
            color="#00457C"
            :disabled="csvFileData == null"
            @click="submitForm"
            >Submit</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="success">
        <v-col cols="12">
          <v-alert type="success">Subscribed customer(s) successfully.</v-alert>
        </v-col>
      </v-row>
      <v-row v-if="error">
        <v-col cols="12">
          <v-alert type="error">Error occurred. Please try again.</v-alert>
        </v-col>
      </v-row>
    </v-container>

    <!-- One-time push notification section -->
    <v-container class="content" style="margin-top: 25px">
      <!--loading screen when add video request is being handled-->
      <LoadingScreen :loading="loadingSendNotif" />

      <div class="header text-left">Send a One-Time Notification</div>
      <!-- Topic -->
      <v-row>
        <v-col cols="4" md="3">
          <label>Topic</label>
          <select v-model="notifTopic">
            <option></option>
            <option
              :key="index"
              v-for="(topicRowDetail, index) in dynamicRowsDetail"
            >
              {{ topicRowDetail.topic }}
            </option>
          </select>
        </v-col>
      </v-row>

      <!-- Title -->
      <v-row>
        <v-col cols="12">
          <label for="ann-title">Title</label>
          <input
            id="ann-title"
            type="text"
            v-model="notfiTitle"
            @input="$v.notfiTitle.$touch()"
          />
          <div
            class="error-msg"
            v-show="$v.notfiTitle.$invalid && $v.notfiTitle.$dirty"
          >
            This is a required field.
          </div>
          <br />
        </v-col>
      </v-row>

      <!-- Content -->
      <v-row>
        <v-col cols="12">
          <label for="ann-content">Content</label>
          <textarea
            id="ann-content"
            v-model="notifBody"
            @input="$v.notifBody.$touch()"
          ></textarea>
          <div
            class="error-msg"
            v-show="$v.notifBody.$invalid && $v.notifBody.$dirty"
          >
            This is a required field.
          </div>
        </v-col>
      </v-row>

      <!-- Send Notification Button -->
      <v-row>
        <v-col cols="6" md="3">
          <v-btn
            color="#00457C"
            :disabled="$v.$invalid"
            @click="sendNotfication"
            >Send Now</v-btn
          >
        </v-col>
      </v-row>

      <v-row v-if="successSendNotif">
        <v-col cols="12">
          <v-alert type="success">Notification sent successfully.</v-alert>
        </v-col>
      </v-row>
      <v-row v-if="errorSendNotif">
        <v-col cols="12">
          <v-alert type="error">Error occurred. Please try again.</v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Axios from "axios";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";
import TableComponent from "./commons/TableComponent";
import Dialog from "./commons/Dialog";

let checkTopic = (value, vm) => {
  if (vm.notifTopic == "") {
    return false;
  } else {
    return true;
  }
};

export default {
  data() {
    return {
      notifTopic: "",
      notfiTitle: "",
      notifBody: "",
      dynamicRowsDetail: [],
      csvFileData: null,
      csvFileName: null,
      topicToAdd: "",

      dialog: false,
      loading: false,
      loading2: false,
      loadingSendNotif: false,
      success: false,
      success2: false,
      successSendNotif: false,
      error: false,
      error2: false,
      errorSendNotif: false,
    };
  },

  created() {
    // Fetch all topics
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/topics/get_all")
      .then(({ data }) => {
        console.log("Successfully retrieved topic list");
        this.dynamicRowsDetail = this.processFetchedData(data);
      })
      .catch((err) => console.log(err));
  },

  components: {
    LoadingScreen,
    TableComponent,
    Dialog,
  },

  validations: {
    notfiTitle: {
      required,
    },
    notifBody: {
      required,
    },
    notifTopic: {
      required,
      checkTopic,
    },
  },

  methods: {
    openDeleteDialog(id) {
      this.dialog = true;
      this.itemDeleteId = id;
    },

    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete
      this.dialog = false;

      // Update MongoDB
      Axios.delete(
        process.env.VUE_APP_HOST_SERVER +
          `/api/topics/delete/${this.itemDeleteId}`
      )
        .then(() => {
          // Remove topic from all users and unsubscribe all users from topic
          Axios.post(
            process.env.VUE_APP_HOST_SERVER +
              `/api/notifications/unsub_topic/all`,
            { topic: this.getTopicFromTopicId(this.itemDeleteId) }
          ).then(() => {
            this.dynamicRowsDetail = this.dynamicRowsDetail.filter(
              (rowDetail) => rowDetail.rowId !== this.itemDeleteId
            );
            this.itemDeleteId = null;
            this.loading = false;
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    processFetchedData(rawMsgData) {
      return rawMsgData.map(({ _id, topic }) => {
        let actionDetails = {};
        if (topic == "All-MY" || topic == "IOS-MY" || topic == "Android-MY") {
          actionDetails = { view: "hide", edit: "hide", delete: "hide" };
        } else {
          actionDetails = { view: "hide", edit: "hide", delete: "show" };
        }
        return {
          rowId: _id,
          topic: topic,
          action: actionDetails,
        };
      });
    },

    getTopicFromTopicId(itemId) {
      return this.dynamicRowsDetail.filter(
        (rowDetail) => rowDetail.rowId === itemId
      )[0].topic;
    },

    setCsvData(file) {
      if (file !== null) {
        // Parse csv file
        this.$papa.parse(file, {
          header: true,
          complete: ({ data }) => {
            // Set csv file
            this.csvFileData = data;

            // Set csv file name
            this.csvFileName = file.name;
          },
        });
      }
    },

    submitForm() {
      this.loading = true;

      Axios.post(process.env.VUE_APP_HOST_SERVER + "/users/topics/add", {
        csvFileData: this.csvFileData,
      })
        .then((res) => {
          console.log(res.data.topics);
          console.log(res.data.usersFCMTokens);
          Axios.post(
            process.env.VUE_APP_HOST_SERVER + "/api/notifications/sub_topic",
            { usersFCMTokens: res.data.usersFCMTokens, topics: res.data.topics }
          ).then((res) => {
            console.log(res.data);
            this.loading = false;
            this.success = true;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.error = true;
          console.log(err);
        });
    },

    addTopic() {
      Axios.post(process.env.VUE_APP_HOST_SERVER + "/api/topics/add", {
        topic: this.topicToAdd,
      })
        .then((res) => {
          this.dynamicRowsDetail.push({
            rowId: res.data._id,
            nonAction: [res.data.topic],
            action: { view: "hide", edit: "hide", delete: "show" },
          });
          this.loading2 = false;
          this.success2 = true;
          console.log(res.data);
        })
        .catch((err) => {
          this.loading2 = false;
          this.error2 = true;
          console.log(err);
        });
    },

    sendNotfication() {
      this.loadingSendNotif = true;
      Axios.post(
        process.env.VUE_APP_HOST_SERVER + "/api/notifications/send_notif/topic",
        {
          title: this.notfiTitle,
          bodyMessage: this.notifBody,
          topic: this.notifTopic,
        }
      )
        .then(() => {
          this.loadingSendNotif = false;
          this.successSendNotif = true;
          this.errorSendNotif = false;
        })
        .catch((err) => {
          this.loadingSendNotif = false;
          this.errorSendNotif = true;
          this.successSendNotif = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

#csvInput {
  display: none;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"] {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}

input[type="text"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}
</style>
